import React from 'react';
import { threeDecimal } from '@utils/format';

const TotalsSection = ({ doctype, total, subtotal, desconto, iva, ivas }) => {
  return (
    <div className="totals">
      <div style={{ 
        marginBottom: '2rem', 
        fontSize: '1.5rem', 
        fontWeight: '700', 
        color: '#1e293b',
        textAlign: 'center',
        letterSpacing: '0.025em',
        textTransform: 'uppercase'
      }}>
        Resumo Financeiro
      </div>
      {doctype.value === 'returns' ? (
        <>
          <div className="total-row">
            <span className="total-label">Total Preço Custo</span>
            <span className="total-value">{threeDecimal(subtotal)} €</span>
          </div>
          {ivas && Object.keys(ivas).length > 0 ? (
            Object.keys(ivas).map(taxKey => (
              ivas[taxKey] > 0 && (
                <div key={taxKey} className="total-row">
                  <span className="total-label">IVA ({taxKey})</span>
                  <span className="total-value">{threeDecimal(ivas[taxKey])} €</span>
                </div>
              )
            ))
          ) : (
            <div className="total-row">
              <span className="total-label">Total IVA</span>
              <span className="total-value">{threeDecimal(iva)} €</span>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="total-row">
            <span className="total-label">Subtotal (s/IVA)</span>
            <span className="total-value">{threeDecimal(subtotal)} €</span>
          </div>
          {desconto > 0 ? (
            <div className="total-row">
              <span className="total-label">Descontos</span>
              <span className="total-value">{threeDecimal(desconto)} €</span>
            </div>
          ) : null}
          {ivas && Object.keys(ivas).length > 0 ? (
            Object.keys(ivas).map(taxKey => (
              ivas[taxKey] > 0 && (
                <div key={taxKey} className="total-row">
                  <span className="total-label">IVA ({taxKey})</span>
                  <span className="total-value">{threeDecimal(ivas[taxKey])} €</span>
                </div>
              )
            ))
          ) : (
            <div className="total-row">
              <span className="total-label">IVA</span>
              <span className="total-value">{threeDecimal(iva)} €</span>
            </div>
          )}
        </>
      )}
      <div className="total-row total-final">
        <span className="total-label">Total</span>
        <span className="total-value">{threeDecimal(total)} €</span>
      </div>
    </div>
  );
};

export default TotalsSection;
